import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StickerConfig, Unit } from "@/lib/sticker";
import { SectionTitle } from "./SectionTitle";
import { UnitSelector } from "./UnitSelector";
import { SizeInput } from "./SizeInput";
import { useTranslation } from "@/lib/i18n";

interface ShapeSizeSectionProps {
  stickerConfig: StickerConfig;
  onShapeChange: (shape: string) => void;
  onSizeChange: (field: string, value: string) => void;
  onUnitChange: (unit: Unit) => void;
}

export const ShapeSizeSection = ({
  stickerConfig,
  onShapeChange,
  onSizeChange,
  onUnitChange,
}: ShapeSizeSectionProps) => {
  const t = useTranslation();

  return (
    <div className="p-4">
      <SectionTitle title={t.sections.shapeAndSize} />

      <div className="space-y-3">
        {/* Shape Selection */}
        <div>
          <Tabs value={stickerConfig.shape} onValueChange={onShapeChange}>
            <TabsList className="grid w-full grid-cols-3 p-1">
              <TabsTrigger
                value="rectangle"
                className="text-xs h-full rounded-sm px-2 cursor-pointer"
              >
                {t.shapes.rectangle}
              </TabsTrigger>
              <TabsTrigger
                value="circle"
                className="text-xs h-full rounded-sm px-2 cursor-pointer"
              >
                {t.shapes.circle}
              </TabsTrigger>
              <TabsTrigger
                value="contour"
                className="text-xs h-full rounded-sm px-2 cursor-pointer"
              >
                {t.shapes.contour}
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>

        {/* Size Controls */}
        <div className="space-y-1.5">
          {stickerConfig.shape === "circle" ? (
            <SizeInput
              label="R"
              value={stickerConfig.size.radius}
              onChange={(value) => onSizeChange("radius", value)}
              unit={stickerConfig.unit}
              onUnitChange={onUnitChange}
            />
          ) : (
            <>
              <SizeInput
                label="W"
                value={stickerConfig.size.width}
                onChange={(value) => onSizeChange("width", value)}
                unit={stickerConfig.unit}
                onUnitChange={onUnitChange}
              />
              <SizeInput
                label="H"
                value={stickerConfig.size.height}
                onChange={(value) => onSizeChange("height", value)}
                showUnit={false}
              />
              {stickerConfig.shape === "contour" && (
                <SizeInput
                  label="O"
                  value={stickerConfig.size.offset}
                  onChange={(value) => onSizeChange("offset", value)}
                  showUnit={false}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
